import React, { useState, useEffect } from 'react';
import { Offcanvas, Button, Form, Spinner } from 'react-bootstrap';

const DomainForm = ({
    showModal,
    handleClose,
    domainId,
    domainData,
    addDomain,
    editDomain,
    domains
}) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        domain_name: '',
        zoneid: '',
        provider: '',
        remarks: '',
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (showModal && !domainData) {
            setFormData({
                domain_name: '',
                zoneid: '',
                provider: '',
                remarks: '',
            });
        } else if (domainData) {
            setFormData({
                domain_name: domainData.domain_name || '',
                zoneid: domainData.zoneid || '',
                provider: domainData.provider || '',
                remarks: domainData.remarks || '',
            });
        }
    }, [domainData, showModal]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.domain_name) newErrors.domain_name = 'Domain Name is required';
        
        const duplicateDomain = Array.isArray(domains) && domains.some(
            (domain) => domain.domain_name === formData.domain_name && domain.id !== domainId && !domain.deleted_at
        );

        if (duplicateDomain) {
            newErrors.domain_name = 'Domain Name must be unique';
        }

        return newErrors;
    };

    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }
        try {
            let apiErrors;
            if (domainData) {
                apiErrors = await editDomain(domainData.id, formData);
            } else {
                apiErrors = await addDomain(formData);
            }

            if (apiErrors && Object.keys(apiErrors).length > 0) {
                setErrors(apiErrors);
            } else {
                setErrors({});
                handleClose();
            }
        } catch (error) {
            console.error("An error occurred:", error);
        } finally {
            setLoading(false);
        }
    };

    const controlStyle = {
        fontSize: '14px',
        borderRadius: '14px',
        height: '39px',
        border: '0.5px solid rgb(232, 233, 237)'
    };

    return (
        <Offcanvas 
            show={showModal} 
            onHide={handleClose} 
            placement="end" 
            style={{ width: '490px' }} 
            backdrop="static"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    {domainId ? 'Edit Domain' : 'Add Domain'}
                </Offcanvas.Title>
            </Offcanvas.Header>
            <hr style={{ margin: 0 }} />

            <Offcanvas.Body>
                <Form onSubmit={handleSubmit}>
                    {/* Domain Name Field */}
                    <Form.Group className="mb-3" controlId="domainName">
                        <Form.Label style={{ fontSize: '13px' }}>Domain Name:</Form.Label>
                        <Form.Control
                            type="text"
                            name="domain_name"
                            value={formData.domain_name}
                            onChange={handleChange}
                            className={`form-control ${errors?.domain_name ? 'is-invalid' : ''}`}
                            style={controlStyle}
                            required
                        />
                        {errors.domain_name && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.domain_name}</div>}
                    </Form.Group>

                    {/* Zone ID Field */}
                    <Form.Group className="mb-3" controlId="zoneId">
                        <Form.Label style={{ fontSize: '13px' }}>Zone ID:</Form.Label>
                        <Form.Control
                            type="text"
                            name="zoneid"
                            value={formData.zoneid}
                            onChange={handleChange}
                            className={`form-control ${errors?.zoneid ? 'is-invalid' : ''}`}
                            style={controlStyle}
                        />
                        {errors.zoneid && <div className="invalid-feedback" style={{ fontSize: '12px' }}>*{errors.zoneid}</div>}
                    </Form.Group>

                    {/* Provider Field */}
                    <Form.Group className="mb-3" controlId="provider">
                        <Form.Label style={{ fontSize: '13px' }}>Provider:</Form.Label>
                        <Form.Control
                            type="text"
                            name="provider"
                            value={formData.provider}
                            onChange={handleChange}
                            className="form-control"
                            style={controlStyle}
                        />
                    </Form.Group>

                    {/* Remarks Field */}
                    <Form.Group className="mb-3" controlId="remarks">
                        <Form.Label style={{ fontSize: '13px' }}>Remarks:</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                            className="form-control"
                            style={{ ...controlStyle, height: 'auto', minHeight: '39px' }}
                        />
                    </Form.Group>

                    <br />

                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={handleClose} className="me-2">
                            Close
                        </Button>
                        <Button variant="primary" type="submit">
                            Save
                        </Button>
                    </div>
                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default DomainForm;
